import type { AppState } from 'redux/app-state';
import { createSelector } from 'reselect';

export const verifyNemadigitalConfigAvailability = createSelector(
  (state: AppState) => state.uiState.global.systemFlags?.P40_25943_nemadigital_config,
  (state: AppState) => state.uiState.auth.permissionFlags?.nemaDigital?.value,
  (systemFlagNemaDigitalConfig, permissionFlagNemaDigital) => !!(permissionFlagNemaDigital && systemFlagNemaDigitalConfig)
);
